<template>
  <div class="group">
    <div class="header">
      <router-link to="/" tag="span">
        <el-button type="primary" size="mini">
          返回
        </el-button>
      </router-link>
    </div>

    <div class="content">
      <div class="sidebar">
        <nodes-tree
          :groupCode="groupCode"
          @update:crtNodeData="onUpdateCrtNodeData"
          @update:crtNodeDataHover="onUpdateCrtNodeDataHover"
          @clickAddAttrBtn="onClickAddAttrBtn"
          @clickAddMemberBtn="onClickAddMemberBtn"
        />
      </div>

      <div class="main">
        <el-tabs v-model="activeTabName" type="card" @tab-click="onTabClick">
          <el-tab-pane label="属性" :name="TAB_ATTR">
            <attrs-table ref="attrsTable" :groupCode="groupCode" :nodeCode="currentNodeCode" />
          </el-tab-pane>
          <el-tab-pane label="成员" :name="TAB_MEMBER">
            <members-table ref="membersTable" :groupCode="groupCode" :nodeCode="currentNodeCode" />
          </el-tab-pane>
        </el-tabs>
      </div>

      <el-dialog
        title="添加属性"
        :visible.sync="isCreateAttrDialogVisible"
        width="30%"
        custom-class="plugin-select-custom-dialog"
        append-to-body
      >
        <el-select
          v-model="selectedAttrs"
          multiple
          placeholder="请选择"
          size="mini"
          style="width: 100%;"
          filterable
          :remote-method="searchAttr"
          :loading="isAttrLoading"
          @change="onSelectedAttrsChange"
          remote
        >
          <el-option
            v-for="item in attrs"
            :key="item.attrCode"
            :label="item.attrName"
            :value="item.attrCode"
          ></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isCreateAttrDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onClickCreateAttrSubmitBtn">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="添加成员"
        :visible.sync="isCreateMemberDialogVisible"
        width="30%"
        custom-class="plugin-select-custom-dialog"
        append-to-body
      >
        <el-select
          v-model="selectedMembers"
          multiple
          placeholder="请选择"
          size="mini"
          style="width: 100%;"
          :remote-method="searchMembers"
          :loading="isMemberLoading"
          @change="onSelectedMembersChange"
          remote
          filterable
        >
          <el-option
            v-for="item in members"
            :key="item.memberCode"
            :label="item.memberName"
            :value="item.memberCode"
          ></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isCreateMemberDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onClickCreateMemberSubmitBtn">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {Icon} from '@x-tech/fe-puma-lib/lib/components';
import AttrsTable from './AttrsTable.vue';
import MembersTable from './MembersTable.vue';
import NodesTree from './NodeTree/NodeTree.vue';
import {
  getAllAttrs,
  getAllMembers,
  addNewMemberToNode,
  addNewAttrToNode,
  searchGroupsMembers,
  searchGroupsAttr
} from '../../apis';

const TAB_ATTR = 'TAB_ATTR';
const TAB_MEMBER = 'TAB_MEMBER';

export default {
  name: 'Group',
  components: {
    Icon,
    NodesTree,
    AttrsTable,
    MembersTable
  },
  data() {
    return {
      groupCode: '',
      currentNodeCode: '',
      currentNodeCodeHover: '',

      selectedAttrs: [],
      selectedAttrsHash: {},
      isCreateAttrDialogVisible: false,
      attrs: [],
      isAttrLoading: false,

      selectedMembers: [],
      selectedMembersHash: {},
      isCreateMemberDialogVisible: false,
      members: [],
      isMemberLoading: false,

      activeTabName: TAB_ATTR,
      TAB_ATTR,
      TAB_MEMBER
    };
  },
  async created() {
    let groupCode = this.$route.params['code'];
    this.groupCode = groupCode;

    // this.attrs = await getAllAttrs(this.groupCode);
    // this.members = await getAllMembers(this.groupCode);
  },
  methods: {
    onSelectedAttrsChange(val = []) {
      val.forEach(code => {
        if (typeof this.selectedAttrsHash[code] === 'undefined') {
          this.attrs.forEach(m => {
            if (m.attrCode === code) {
              this.selectedAttrsHash[code] = m.attrName;
            }
          });
        }
      });
    },
    onSelectedMembersChange(val = []) {
      val.forEach(code => {
        if (typeof this.selectedMembersHash[code] === 'undefined') {
          this.members.forEach(m => {
            if (m.memberCode === code) {
              this.selectedMembersHash[code] = m.memberName;
            }
          });
        }
      });
    },
    onTabClick() {},
    onUpdateCrtNodeDataHover(data = {}) {
      this.currentNodeCodeHover = data.nodeCode;
    },
    async onClickCreateAttrSubmitBtn() {
      if (this.selectedAttrs.length > 0) {
        let res = await addNewAttrToNode(this.groupCode, this.currentNodeCodeHover, this.selectedAttrs);
        this.selectedAttrs = [];
        this.isCreateAttrDialogVisible = false;
        this.$refs.attrsTable.getData();
      }
    },
    async onClickCreateMemberSubmitBtn() {
      if (this.selectedMembers.length > 0) {
        let res = await addNewMemberToNode(this.groupCode, this.currentNodeCodeHover, this.selectedMembers);
        this.selectedMembers = [];
        this.isCreateMemberDialogVisible = false;
        this.$refs.membersTable.getData();
      }
    },
    async searchMembers(key = '') {
      if (key) {
        this.isMemberLoading = true;
        let res = await searchGroupsMembers(this.groupCode, '', key);
        this.isMemberLoading = false;

        let resHash = {};
        res.forEach(m => {
          resHash[m.memberCode] = true;
        });

        let selectedOptions = [];
        this.selectedMembers.forEach(code => {
          if (!resHash[code]) {
            selectedOptions.push({memberCode: code, memberName: this.selectedMembersHash[code]});
          }
        });

        let membersUniq = [];
        let members = [...res, ...selectedOptions];
        let memberHash = {};
        members.forEach(m => {
          if (typeof memberHash[m.memberCode] === 'undefined') {
            membersUniq.push(m);
            memberHash[m.memberCode] = true;
          }
        })
        this.members = membersUniq;
      }
    },
    async searchAttr(key = '') {
      if (key) {
        this.isAttrLoading = true;
        let res = await searchGroupsAttr(this.groupCode, '', key);
        this.isAttrLoading = false;

        let resHash = {};
        res.forEach(m => {
          resHash[m.memberCode] = true;
        });

        let selectedOptions = [];
        this.selectedAttrs.forEach(code => {
          if (!resHash[code]) {
            selectedOptions.push({attrCode: code, attrName: this.selectedAttrsHash[code]});
          }
        });

        let attrsUniq = [];
        let attrs = [...res, ...selectedOptions];
        let attrHash = {};
        attrs.forEach(a => {
          if (typeof attrHash[a.attrCode] === 'undefined') {
            attrsUniq.push(a);
            attrHash[a.attrCode] = true;
          }
        })
        this.attrs = attrsUniq;
      }
    },
    onClickNodeSubmitBtn() {
      this.isCreateNodeDialogVisible = false;
    },
    onClickAddAttrBtn({nodeCode}) {
      this.isCreateAttrDialogVisible = true;
    },
    onClickAddMemberBtn({nodeCode}) {
      this.isCreateMemberDialogVisible = true;
    },
    onUpdateCrtNodeData(nodeData) {
      this.currentNodeCode = nodeData.nodeCode;
    }
  }
};
</script>

<style lang="scss" scoped>
.group {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.content {
  display: flex;
  flex: 1;
  width: 100%;
  height: calc(100vh - 50px);
}

.header {
  padding: 0px 20px;
  height: 20px;
  line-height: 20px;
}

.sidebar {
  width: 240px;
  height: 100%;
  border-right: 1px solid rgba(235, 238, 245, 1);
  padding: 8px;
  box-sizing: border-box;
  overflow: scroll;
}

.main {
  flex: 1;
  overflow: hidden;
  padding: 8px 16px;
  box-sizing: border-box;
  overflow: scroll;
  height: 100%;
}
</style>
